module.exports = __webpack_public_path__ + "pipelines_account.png";